class NaviView {
  constructor() {
    this.isShow = false;
    this.isAnimating = false;
    this.navi = document.querySelector('.p-navi');
    if (!this.navi) return;

    this.toggle = this.navi.querySelector('.p-navi__toggle');
    this.bg = this.navi.querySelector('.p-navi__bg');

    this.toggle.addEventListener('click', () => {
      if (this.isAnimating) return;
      if (this.isShow) {
        this.hide();
      } else {
        this.show();
      }
    });

    this.bg.addEventListener('click', () => {
      if (this.isShow) {
        this.hide();
      }
    });

    window.addEventListener('resize', this.listen.bind(this));
  }

  ////////////////////////////////////////////////////////////

  listen(param) {
    switch (param) {
      case 'resize':
        this.resize();
        break;
    }
  }

  ////////////////////////////////////////////////////////////

  resize() {
    let wh = window.innerHeight;
    this.navi.style.height = `${wh}px`;
  }

  ////////////////////////////////////////////////////////////

  ready() {}

  show() {
    this.isShow = true;
    this.navi.classList.add('-show');
    this.toggle.classList.add('-open');
  }

  hide() {
    this.isAnimating = true;
    this.isShow = false;
    this.navi.classList.add('-hide');
    this.toggle.classList.add('-close');

    let wait = 1000;

    setTimeout(() => {
      this.navi.classList.remove('-show');
      this.navi.classList.remove('-hide');
      this.toggle.classList.remove('-open');
      this.toggle.classList.remove('-close');
      this.isAnimating = false;
    }, wait);
  }
}

new NaviView();
